import { createContext } from "react";
import Container, { container } from "src/shared/services/container/container.service";

export const ContainerContext = createContext<Container>(container);
